import { useState } from 'react';

// Edit/Save/Cancel for the survey answers. Answers live in a local draft while editing and are only
// written on Save; photos are not part of this (they still save on upload).
export const useSurveyEditor = ({ saveSurveyResponses }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState({});

    const startEditing = () => {
        setDraft({});
        setIsEditing(true);
    };

    const cancel = () => {
        setDraft({});
        setIsEditing(false);
    };

    const setAnswer = (survey_id, value) => setDraft((prev) => ({ ...prev, [survey_id]: value }));

    // Stay in edit mode on failure so the draft isn't lost.
    const save = async () => {
        const saved = await saveSurveyResponses(draft);
        if (saved) cancel();
    };

    return { isEditing, draft, startEditing, cancel, setAnswer, save };
};
